import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useUXPContext } from '@core/context/useUXPContext';
import { useLogout } from '@core/services/useLogout';
export const PermissionChangedBanner = ({ expiresAt }) => {
    const context = useUXPContext();
    const logout = useLogout();
    const [seconds, setSeconds] = useState(() => Math.max(0, expiresAt - Math.floor(Date.now() / 1000)));
    const expired = seconds <= 0;
    useEffect(() => {
        if (expired)
            return;
        const id = setTimeout(() => setSeconds(Math.max(0, expiresAt - Math.floor(Date.now() / 1000))), 1000);
        return () => clearTimeout(id);
    }, [seconds, expired, expiresAt]);
    return (_jsxs("div", { className: "uxpcore_permissionbanner__container", children: [_jsx("span", { children: expired
                    ? context.$L('uxp-core.permission-changed.expired')
                    : context.$L('uxp-core.permission-changed.message', { seconds }) }), _jsx("button", { className: "uxpcore_permissionbanner__btn", onClick: logout, children: context.$L('uxp-core.permission-changed.logout-now') })] }));
};
